export default __webpack_public_path__ + "static/media/close-menu-icon.b53a5dd7.svg";